
































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";

@Component({
  components: { VCDateTimePicker }
})
export default class MonitoringTransfusiReaksiPanel extends Vue {
  @Prop() monitoringId!: number;
  @Prop({ default: () => [] }) reaksis!: any[];
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: null }) seedWaktu!: string | null;

  showDialog = false;
  editingReaksi: any = null;
  savingReaksi = false;
  reaksiForm: any = {};

  reaksiHeaders = [
    { text: "Waktu", value: "waktu_kejadian", width: "120px" },
    { text: "Mnt ke", value: "menit_ke", width: "60px" },
    { text: "Jenis", value: "label_jenis_reaksi", width: "120px" },
    { text: "Derajat", value: "derajat", width: "90px" },
    { text: "Tindakan", value: "tindakan" },
    { text: "Stop", value: "transfusi_dihentikan", width: "50px" },
    { text: "Aksi", value: "actions", sortable: false, width: "80px" },
  ];

  jenisReaksiOptions = [
    { text: "Demam", value: "demam" },
    { text: "Menggigil", value: "menggigil" },
    { text: "Urtikaria", value: "urtikaria" },
    { text: "Pruritus", value: "pruritus" },
    { text: "Sesak Napas", value: "sesak_napas" },
    { text: "Nyeri Dada", value: "nyeri_dada" },
    { text: "Nyeri Punggung", value: "nyeri_punggung" },
    { text: "Hipotensi", value: "hipotensi" },
    { text: "Hipertensi", value: "hipertensi" },
    { text: "Takikardia", value: "takikardia" },
    { text: "Hemoglobinuria", value: "hemoglobinuria" },
    { text: "Anafilaksis", value: "anafilaksis" },
    { text: "TRALI", value: "trali" },
    { text: "TACO", value: "taco" },
    { text: "Lainnya", value: "lainnya" },
  ];

  derajatOptions = [
    { text: "Ringan", value: "ringan" },
    { text: "Sedang", value: "sedang" },
    { text: "Berat", value: "berat" },
  ];

  get waktuKejadianDate(): Date | null {
    return composeDate(
      this.reaksiForm.waktu_kejadian,
      (this.reaksiForm.waktu_kejadian || "").slice(11, 16)
    );
  }
  set waktuKejadianDate(val: Date | null) {
    this.$set(
      this.reaksiForm,
      "waktu_kejadian",
      val ? `${toDateString(val)} ${toTimeString(val)}:00` : null
    );
  }

  bukaDialogBaru() {
    this.editingReaksi = null;
    this.reaksiForm = {
      waktu_kejadian: moment(this.seedWaktu || undefined).format("YYYY-MM-DD HH:mm:ss"),
    };
    this.showDialog = true;
  }

  editReaksi(item: any) {
    this.editingReaksi = item;
    this.reaksiForm = { ...item };
    if (this.reaksiForm.waktu_kejadian) {
      this.reaksiForm.waktu_kejadian = moment(this.reaksiForm.waktu_kejadian).format("YYYY-MM-DD HH:mm:ss");
    }
    this.showDialog = true;
  }

  async hapusReaksi(item: any) {
    if (!confirm("Hapus data reaksi ini?")) return;
    try {
      const resp = await MonitoringTransfusiSvc.deleteReaksi(this.monitoringId, item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus reaksi");
        this.$emit("saved");
      }
    } catch {
      // handled
    }
  }

  closeDialog() {
    this.showDialog = false;
    this.editingReaksi = null;
    this.reaksiForm = {};
  }

  async simpanReaksi() {
    this.savingReaksi = true;
    try {
      let resp;
      if (this.editingReaksi) {
        resp = await MonitoringTransfusiSvc.updateReaksi(this.monitoringId, this.editingReaksi.id, this.reaksiForm);
      } else {
        resp = await MonitoringTransfusiSvc.addReaksi(this.monitoringId, this.reaksiForm);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(this.editingReaksi ? "Reaksi diperbarui" : "Reaksi dilaporkan");

        // Check auto-stop
        if (resp.data.auto_stopped) {
          setTimeout(() => {
            alert("TRANSFUSI DIHENTIKAN OTOMATIS\nReaksi berat terdeteksi — transfusi telah dihentikan.");
          }, 500);
        }

        this.closeDialog();
        this.$nextTick(() => {
          this.$emit("saved");
        });
      }
    } catch {
      // handled
    }
    this.savingReaksi = false;
  }

  formatTime(val: string) {
    if (!val) return "-";
    return moment(val).format("DD/MM HH:mm");
  }
}
